import {
  SavedQueriesList,
  FilterLiveSearch,
  FilterList,
  FilterListItem,
  useTranslate,
  Loading,
} from 'react-admin';
import { Box, Card, CardContent, Stack } from '@mui/material';
import {
  AccountBalance,
  AttachMoney,
  Category,
  History,
} from '@mui/icons-material';
import { addMonths, addWeeks, addYears } from 'date-fns';
import { useCategories } from '../../../hooks/product/useCategories';
import { CategoryModel } from '../../../config/types/models';
import { useBackendTranslate } from '../../../hooks/settings/useBackendTranslation';

const FilterByCategories = ({
  data,
  isLoading,
}: {
  data: CategoryModel[];
  isLoading: boolean;
}) => {
  const getTranslation = useBackendTranslate();
  const t = useTranslate();

  if (isLoading) {
    return <Loading />;
  }
  return (
    <FilterList label={t('categories')} icon={<Category />}>
      {data?.map((category: CategoryModel) => (
        <FilterListItem
          key={category.id}
          label={
            <Stack direction='row' alignItems={'center'}>
              <img src={category.image} style={{ width: 50, height: 'auto' }} />
              <span>{getTranslation(category, 'name')}</span>
            </Stack>
          }
          value={{
            categories: {
              some: {
                id: category.id,
              },
            },
          }}
        />
      ))}
    </FilterList>
  );
};

export const FilterProduct = () => {
  const { data, isLoading } = useCategories();
  if (isLoading) {
    return <Loading />;
  }
  return (
    <Box
      sx={{
        display: {
          xs: 'none',
          sm: 'block',
        },
        marginTop: '4rem',
        order: -1, // display on the left rather than on the right of the list
        width: '18em',
        marginRight: '1em',
      }}
    >
      <Card>
        <CardContent>
          <FilterLiveSearch source='name' />
          <FilterByCategories data={data} isLoading={isLoading} />
        </CardContent>
      </Card>
    </Box>
  );
};
